import React from "react";
import { useMediaQuery } from 'diginet-core-ui/utils';
const  withCustomHook = (Component) => {
    return function WrappedComponent(props) {
        const isMatchMediaQuery = useMediaQuery('(max-width: 1000px)');
        return <Component {...props} isMatchMediaQuery={isMatchMediaQuery} />;
    }
};

export default withCustomHook;